export const MetaPixel = {
  sync(state) {
    if (typeof window.fbq !== 'function') return;
    window.fbq('consent', state.marketing ? 'grant' : 'revoke');
  },
};
